import { useDataValue } from 'Simple/Data.js'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  let patient = useDataValue({
    context: 'task',
    viewPath: props.viewPath,
    path: 'patient',
  })
  return patient
}
